module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-1c98381ad2e93cac0f87b1936eead3a5.jpg";